import React from 'react'
import { TextField } from '@mui/material'


const MuiTextField = (props) => {
  const { width, ...rest } = props
  return (
    <div style={{ width }}>
      <TextField {...rest} style={{ width: '100%' }} />
    </div>
  )
}

export default MuiTextField
